import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function PaymentStripeRedirectModal({ showModal, close, invoice_data, embedded = false }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleStripePayment = async () => {
    setLoading(true); // Comienza la carga (muestra algún tipo de indicador de carga)

    try {
      // Llamar al backend para crear la sesión de Stripe
      const response = await fetch('/api/payment_stripe_redirect', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          invoice_id: invoice_data.id,
          amount_residual: invoice_data.amount_residual,
          currency: invoice_data.currency,
          invoice_name: invoice_data.name,
        }),
      });

      // Verificar que la respuesta es válida
      if (response.ok) {
        const sessionData = await response.json();
        // Redirigir al usuario a Stripe con la URL de la sesión
        if (sessionData.checkout_url) {
          window.location.href = sessionData.checkout_url; // Redirigir a Stripe
        }
      } else {
        throw new Error('Error al crear la sesión de pago');
      }
    } catch (error) {
      console.error('Error al procesar el pago:', error);
      setLoading(false);
      // Aquí puedes mostrar un mensaje de error al usuario
    }
  };

  const content = (
    <>
      <div className="text-dark pb-2 text-center">
        <strong>{t('invoice')} {invoice_data.name}</strong>
      </div>
      <div className="text-dark pb-2 fw-bold text-center">
        <strong>{t('total-to-pay')} {invoice_data.amount_residual} {invoice_data.currency}</strong>
      </div>
      <div className="d-flex justify-content-center">
        <Button variant="success" type="button" onClick={handleStripePayment} disabled={loading}>
          <i className="ri-check-line me-1"></i> {t('pay-stripe')}
        </Button>
      </div>
    </>
  );

  if (embedded) {
    return content;
  }

  return showModal ? (
    <Modal show={showModal} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title className="modal-title text-dark text-center">
          {t('confirm-and-pay')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">{content}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={close}>
          <i className="ri-close-line me-1"></i> {t('btn-close')}
        </Button>
      </Modal.Footer>
    </Modal>
  ) : null;
}

export default PaymentStripeRedirectModal;
